/**
 * FAQページ：SP用カテゴリー選択プルダウンの開閉
 */
const faqNavSp = () => {
  const btn = document.querySelector('.js-faqNavSp');
  const list = document.getElementById('faqNavSpList');
  if (!btn || !list) return;

  btn.addEventListener('click', () => {
    const isOpen = list.hidden === false;
    list.hidden = isOpen;
    btn.setAttribute('aria-expanded', !isOpen);
    btn.closest('.faqNavSp')?.classList.toggle('is-open', !isOpen);
  });

  list.querySelectorAll('.faqNavSp__link').forEach((link) => {
    link.addEventListener('click', () => {
      list.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
      btn.closest('.faqNavSp')?.classList.remove('is-open');
    });
  });
};

faqNavSp();
